<template>
  <div>
    <h1 class="logintitle">
    </h1>
    <div class="loginbox">
      <div class="loginbox-round">

      </div>
      <img class="content-title" src="../../assets/job/images/title.jpg">
      <form method="post" @submit.stop.prevent="submit">
        <ul>
          <li class="input-icon">
            <div>
              <input v-model.trim="username" @input="clearErrMsg" name="username" autocomplete="off" type="text" placeholder="请输入用户名">
            </div>
            <span v-show="invalidUsername">{{ errorMsg }}</span>
          </li>
          <li class="input-icon icon-pwd">
            <div>
              <input v-model.trim="password" @input="clearErrMsg" name="password" autocomplete="off" type="password" placeholder="请输入密码">
            </div>
            <span v-show="invalidPassword">您输入的密码有误</span>
          </li>
          <li>
            <button class="login-btn" type="submit">登陆</button>
          </li>
        </ul>
      </form>
    </div>
    <div class="loginbm">
      <!-- <h4>星图考培信息系统</h4> -->
      <!-- <p>Star Map exam&training Information System</p> -->
      <p><a href="https://job.jiemo.net">星火数据信息平台 job.jiemo.net Copyright © {{ year }} JOB. All Rights Reserve</a></p>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import lockr from 'lockr';

export default {
  name: 'Login',
  data() {
    return {
      invalidUsername: false,
      invalidPassword: false,
      username: '',
      password: '',
      errorMsg: '',
    };
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    }
  },
  methods: {
    clearErrMsg() {
      this.invalidUsername = false;
    },
    submit() {
      if (!this.username) {
        this.invalidUsername = true;
        return false;
      }
      _post({
        url: '/index/login/index',
        data: {
          username: this.username,
          password: this.password
        }
      }).then((res) => {
        if (res.code > 0) {
          this.errorMsg = res.msg;
          this.invalidUsername = true;
          return false;
        }
        lockr.set('jwt', res.data);
        window.location.href = '/';
      });
      return false;
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
  }
};
</script>
<style>
  body {
    height: 100%;
    background-image: url('../../assets/job/images/starFirBg.png');
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  #app {
    padding-top: 130px;
    height:100%;
  }
</style>
<style scoped>

h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
input {
  border: none;
  width: 310px;
  height: 50px;
  border: none;
  line-height: 50px;
  font-size: 16px;
  outline: none;
  margin-left: 50px;
  color: #333 !important;
  font-family: "微软雅黑", Microsoft Yahei;
  padding: 0 10px 0 0;
}
input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #9fa1b0;
}
input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #9fa1b0;
}
input::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #9fa1b0;
}
input:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #9fa1b0;
}
.input-icon > div{
  margin: 10px 0 20px 0;
  background: url(../../assets/job/images/loginname.png) no-repeat 20px center !important;
}
.icon-pwd > div{
  background: url(../../assets/job/images/loginpassword.png) no-repeat 20px center !important;
}
.login-btn {
  background-color: #005cff;
  cursor: pointer;
  color: #FFF !important;
  height: 50px;
  line-height: 50px;
  width: 100%;
  border: none;
  border-radius: 5px;
  font-size: 18px;
}
.logintitle {
  /* text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite; */
  height: 78px;
}
.loginbox {
  background: #fff;
  width: 575px;
  height: 430px;
  margin: auto;
  text-align: center;
  padding-bottom: 30px;
  animation: loginmove 1s ease-out 1;
  -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px;
  position: relative;
}
.loginbox-round{
    width: 160px;
    height: 160px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: -80px;
    background: #fff;
}
.loginbox .content-title{
  display: inline-block;
  transform: translateY(-50px);
  margin-bottom: -25px;
}

.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 5px 0;

}
.loginbox ul li > div{
  border: 1px solid #e2e2e2;
  -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  bottom: 0;
  display: block;
  width: 211px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  background-color: #fcd71d;
  font-size: 18px;
  color: #383838;
}
.loginbox ul li i{
  font-size: 16px;
  color: #9b9b9b;
  line-height: 22px;
  display: block;
  text-align: left;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
  margin-top: -10px;
}

.loginbm {
  line-height: 23px;
  text-align: center;
  padding-top: 30px;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}

.loginbm a {
  font-weight: bold;
  color: #fff;
}

.loginbm a:hover {
  color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #333;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}

</style>
